import { actionTypes, flightTypes, workplaceTypes } from "../types";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { modalContainer } from "../Modal/ModalContainer";
import moment from "moment";
import { TIME_FORMAT } from '@/utils.js';
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

const UserTask = {
    
    state: {
        response: null,
        time: null,
        tasks: [],
        error: '',
        data: null,
        loading: false,
        topMenu: [
            { title: 'Задачи', url: '/', icon: 'fa-tasks' },
            { title: 'Профиль', url: '/profile', icon: 'fa-user' },
            isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
            { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
        ]
    },

    init: async function (ping) {
        try {
            this.state.loading = true;
            const response = await m.request({
                method: 'GET',
                url: '/api/tasks',
                extract(xhr) {
                    UserTask.state.response = xhr;
                    if (xhr.status / 100 !== 2) 
                        throw new Error('Ошибка')
                    return xhr.response;
                }
            });

            server.setOnline();

            this.state.time = response.time;
            this.state.tasks = response.tasks;
            appNotification.list = response.notifications;

            if (appNotification.notifications.length > 0) {
                modalContainer.open();
                const audio = document.querySelector('.sound-playback');
                if (audio) {
                    try {
                        await audio.play();
                        console.log("Звук играет!");
                    } catch (e) {
                        console.error("Ошибка воспроизведения звука:", e);
                    }
                }
            }

            appNotification.filterNotes();
            if (appNotification.filteredNotes.length > 0 &&
                appNotification.filteredNotes.some(note => !note.IsRead)) {
                modalContainer.open();
            }

            storage.config = response.config;

            if (ping) {
                server.initPing();
                appNotification.init();
            }

            return response;

        } catch (error) {
            if (error && error.message) {
                if ([401,403].includes(this.state.response.status)) {
                    localStorage.clear();
                    document.location.href = "/login";
                }
                this.state.error = m(".alert.alert-warning", error.message);
            } else {
                server.setOffline();
            }
            //throw error; // Можно пробросить ошибку дальше, если нужно
        } finally {
            loader.hide();
            this.state.loading = false;
            m.redraw();
        }
    },

    confirm: async function (key) {
        this.state.error = '';
        loader.show();

        const task = this.state.tasks[key];

        try {
            await m.request({
                method: 'PUT',
                url: '/api/task/' + task.id + '/confirm'
            });

            task.isConfirmed = true;
            task.url = user.get('state.workplace') === workplaceTypes.executor
                ? '/task/' + task.id + '/works'
                : '/task/' + task.id + '/schedule';

        } catch (error) {
            cache.push({
                type: actionTypes.taskConfirm,
                taskId: task.id,
                ts: moment().format(TIME_FORMAT)
            });

            if (error && error.message) {
                this.state.error = m(".alert.alert-danger", error.message);
            } else {
                server.setOffline();
            }
        } finally {
            loader.hide();
            m.redraw();
        }
    },

    loadData: async function (ping) {
        try {
            this.state.loading = true;
            const response = await this.init(ping);
            this.state.data = response; // Сохраняем данные
            return response;
        } catch (error) {
            console.error("Ошибка загрузки задач:", error);
            // throw error
        } finally {
            this.state.loading = false;
            m.redraw();
        }
    },

};

export const UserTasksPage = {
    controller: function () {
        if (!user.exists()) {
            m.route('/login');
            return;
        }
        if (!user.has('state.workplace')) {
            m.route('/workplace');
            return;
        }
        if (user.get('state.workplace') === workplaceTypes.driver) {
            m.route('/vehicle/tasks');
            return;
        }
        if (user.get('state.workplace') === workplaceTypes.conveyer) {
            m.route('/conveyer/flights');
            return;
        }
        if (user.get('state.workplace') === workplaceTypes.agent) {
            m.route('/agent/tasks');
            return;
        }
        if (user.get('state.workplace') === workplaceTypes.security) {
            m.route('/security/flights');
            return;
        }

        interval.clearAll();

        loader.show();

        UserTask.loadData(true)
        .then(() => { 
            interval.make(() => {
                UserTask.loadData(false).catch(e => console.error("Auto-refresh error:", e));
            }, 30000);
        })
        .catch(error => {
           console.error("Ошибка загрузки данных:", error); 
        })
        .finally(() => {
            loader.hide();
        });

        // Добавляем очистку при размонтировании
        return {
            ...UserTask.state,
            onunload: () => interval.clearAll()
        };
    },

    displayReadiness: function (task) {
        const readiness = UserTask.state.data?.readiness?.[task.id]
        if (!readiness)
            return;

        const time = moment(readiness.updated_at, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
        return parseInt(readiness.status)
            ? m("div.text-white[style='font-size:0.8em;line-height:1;background:green;']", `готовность ${time}`)
            : m("div.text-white[style='font-size:0.8em;line-height:1;background:red;']", `отмена готовности ${time}`)
    },

    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: UserTask.state.time,
                menu: UserTask.state.topMenu
            }),
            m("div[style='margin-top:0px']", UserTask.state.error),
            m("table.table.table-bordered.table-condensed", [
                m("thead", [
                    m("tr", [
                        m("th.text-center.v-center", "Работа"),
                        m("th.text-center.v-center", "Время"),
                        m("th.text-center.v-center", "МС\nВС"),
                        m("th", "")
                    ])
                ]),
                m("tbody", [
                    UserTask.state.tasks.map(function (task, i) {
                        return m("tr", { class: task.isOverdue ? 'bg-grey' : '' }, [
                            m("td", [
                                m("a.btn.btn-block.btn-lg", {
                                    href: (!task.isConfirmed && task.flightType == -1) ? '' : task.url,
                                    class: task.hasAlerts ? 'btn-warning progress-bar-striped' : 'btn-default',
                                    config: m.route
                                }, [

                                    task.isCrossWork ? m("i.fa.fa-2x.fa-exclamation") : '',
                                    m("div.d-flex.flex-column", [
                                        m('', [
                                            m('', task.NR_dep != "" && task.NR_arr != "" ?
                                                task.NR_arr + "/" + task.NR_dep
                                                : task.flightNumber),
                                            //task.flightType > -1 ? m("br") : '',
                                            task.flightType === flightTypes.departure ?
                                                [m('img', { src: "/img/departure.png" }), m.trust('&nbsp;' + task.airportCode)] : '',
                                            task.flightType === flightTypes.arrival ?
                                                [m('img', { src: "/img/arrival.png" }), m.trust(task.airportCode + '&nbsp;')] : '',
                                            task.flightType === flightTypes.around ?
                                                [m('img', { src: "/img/around.png" }), m.trust('&nbsp;' + task.airportCode)] : '',
                                        ]),
                                        m('', task.Work_Name),
                                        UserTasksPage.displayReadiness(task)
                                    ])
                                ])
                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", task.workPlanBegin),
                                task.flightType > -1 ? m("br") : '',
                                task.flightType > -1 ? m("span", task.flightTime + ' ') : '',
                                m("br"),
                                m("span.small-text", task.flightDate),
                                task.EntranceZoneTime ? [
                                    m("br"),
                                    m("span.small-text[style='color:red; font-size:15px']", "Вход АП"),
                                    m("br"),
                                    m("span.small-text[style='color:red; font-size:20px']", task.EntranceZoneTime)] : []

                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", task.parkingNumber),
                                m("br"),
                                m("span", task.typeVS),
                                m("br"),
                                m("span", task.boardNumber),
                                task.SectorBagClaim !== null ? [
                                    m("br"),
                                    m("span", "СБ: " + task.SectorBagClaim)
                                ] : []
                            ]),
                            m("td.col-xs-2.text-center.v-center", [
                                task.isConfirmed ?
                                    m("i.fa.fa-3x.fa-check.text-primary") :
                                    m("button.btn.btn-info.btn-lg", {
                                        onclick: function () {
                                            UserTask.confirm(i);
                                        }
                                    }, [
                                        m("i.fa.fa-2x.fa-thumbs-o-up")
                                    ])
                            ])
                        ])
                    })
                ])
            ])
        ];
    }
};
